export default __webpack_public_path__ + "static/media/s4_scape3.0ffb06cc.png";